import { render, staticRenderFns } from "./AzureCost.vue?vue&type=template&id=e995615a&scoped=true"
import script from "./AzureCost.vue?vue&type=script&lang=js"
export * from "./AzureCost.vue?vue&type=script&lang=js"
import style0 from "./AzureCost.vue?vue&type=style&index=0&id=e995615a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e995615a",
  null
  
)

export default component.exports